// page_scroll_helpers.js

//
function scrollTo(elem, offset, time_offset){
  let target_y,
      start_y = window.pageYOffset;

  if (time_offset === undefined) time_offset = 0;
  if (offset === undefined) offset = 0;
  if (typeof(elem) === 'number') {
    target_y = elem + offset;
  } else {
    target_y = getElementOffsetTop(elem) + offset;
  }

  setTimeout(smoothScroll, time_offset, target_y, start_y, 10)
}

// получает реальный оффсет от верха страницы для элемента.
// рекурсивная функция, учитывает оффсеты родителей.
function getElementOffsetTop(elem){
  // console.log('geot:', elem);
  if (typeof(elem) === 'string') {
    elem = document.getElementById(elem);
  }
  let parent = elem.offsetParent;
  if (parent === null) {
    return elem.offsetTop
  } else {
    return getElementOffsetTop(parent) + elem.offsetTop;
  }

}

// Функция с рекурсивным таймаутом обеспечивающая плавный скролл
function smoothScroll(target_y, start_y, ms, speed){
  // console.log('smoothScroll', target_y, start_y, window.pageYOffset,  speed);
  // window.scrollTo(pageX,pageY)
  speed = scrollStepY(target_y, start_y, 20, speed);
  if (!isScrollFinished(target_y, start_y)){
    window.scrollBy(0, speed);
    setTimeout(smoothScroll, ms, target_y, start_y, ms, speed)
  } else {
    // console.log('Scrolled!');
  }
}

// проверяет достигли ли мы конечной точки скролла
function isScrollFinished(target_y, start_y){
  let current_y = window.pageYOffset;
  if (target_y > start_y) {
    return (target_y <= current_y)
  } else {
    return (target_y >= current_y)
  }
}

// возвращает длину одного шага скролла в пикселах
function scrollStepY(target, start, max_speed, speed){
  // задаем минимальную скорость если не задана.
  if (speed === undefined) speed = 1;
  // работаем только с положительным значением.
  speed = Math.abs(speed);

  let current = window.pageYOffset;
  // Определяем сколько осталось до конечного положения.
  let way = Math.abs(target - current);

  // управляем скоростью исходя из длины тормозного пути
  if (way > stopWayLine(speed)) {
    if (speed < max_speed) speed++;
  } else {
    if (speed > 1) speed--;
  }

  if (target > start) {
    return speed;
  } else {
    return -speed;
  }
}

// считает длину тормозного пути
function stopWayLine(speed){
  let i, line = 0;
  for(i=speed; i>=1; i--){
    line += i;
  }
  return line;
}



function getDocHeight(){
  let scrollHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
  return scrollHeight
}




export {
  scrollTo
}